<template>
  <div >
      <Bloco :dados="dados"   t="d"/>
      <br>
      <br>
  </div>
</template>

<script>
import calculo from '../services/calculo'
import Bloco from '../components/Bloco.vue'
export default {
    components:{
        Bloco
    },
    data(){
        return{
            dados:[]
        }
    },
    methods:{

    },
    async mounted(){
        let result = await calculo.Legislacao()
        this.dados = result.data
    }
}
</script>

<style>

</style>